export var SocialMediaPlatforms;
(function (SocialMediaPlatforms) {
    SocialMediaPlatforms["Instagram"] = "instagram";
    SocialMediaPlatforms["TikTok"] = "tiktok";
    SocialMediaPlatforms["Twitter"] = "twitter";
    SocialMediaPlatforms["Facebook"] = "facebook";
    SocialMediaPlatforms["Youtube"] = "youtube";
    SocialMediaPlatforms["Tracdelight"] = "tracdelight";
})(SocialMediaPlatforms || (SocialMediaPlatforms = {}));
const SocialLinkRegExp = {
    facebook: {
        reel: /https:\/\/www\.facebook\.com\/reel\/([0-9]+)/,
        postVideo: /https:\/\/www\.facebook\.com\/.+\/(posts|videos)\/([0-9]+)/,
        photo: /https:\/\/www\.facebook\.com\/.+\/photos\/.+/,
        embedPost: /https:\/\/www\.facebook\.com\/plugins\/post\.php\?.*href=([a-zA-Z0-9%=._+-]+)/,
        embedVideo: /https:\/\/www\.facebook\.com\/plugins\/video\.php\?.*href=([a-zA-Z0-9%=._+-]+)/,
        short: /https:\/\/fb\.watch\/([a-zA-Z0-9_-]+)\/?/,
        embedPhoto: /https:\/\/www\.facebook\.com\/photo\.php\?fbid=(\d+)&([a-zA-Z0-9%=.;&_]+)/,
    },
    instagram: {
        link: /https:\/\/www\.instagram\.com\/(tv|p|reel)?\/(.+?)\//,
        shortcode: /data-shortcode="([^"]+)"/,
    },
    tiktok: /https:\/\/www\.tiktok\.com\/(@[^"&?/\s]+)\/(video|photo)\/(\d+)/,
    twitter: /https:\/\/(twitter|x)\.com\/([^/]+)\/status\/([0-9]+)\/?/,
    youtube: {
        video: /https:\/\/(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
        short: /https:\/\/(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/,
        embed: /https:\/\/(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]+)/,
        live: /https:\/\/(?:www\.)?youtube\.com\/live\/([a-zA-Z0-9_-]+)/,
        shortLink: /https:\/\/youtu\.be\/([a-zA-Z0-9_-]+)/,
        videoId: /data-videoid="([^"]+)"/,
    },
    tracdelight: /https:\/\/scripts.tracdelight\.io\/([^/]+)\/([^/]+)\/?/,
};
// eslint-disable-next-line @rushstack/typedef-var -- disable scoped to legacy integration boundary in this file
const SocialLinkValidation = {
    isInstagram: (url) => SocialLinkRegExp.instagram.link.test(url) || SocialLinkRegExp.instagram.shortcode.test(url),
    isTwitter: (url) => SocialLinkRegExp.twitter.test(url),
    isTiktok: (url) => SocialLinkRegExp.tiktok.test(url),
    isFacebook: (url) => SocialLinkRegExp.facebook.reel.test(url) ||
        SocialLinkRegExp.facebook.postVideo.test(url) ||
        SocialLinkRegExp.facebook.embedPost.test(url) ||
        SocialLinkRegExp.facebook.embedVideo.test(url) ||
        SocialLinkRegExp.facebook.short.test(url) ||
        SocialLinkRegExp.facebook.embedPhoto.test(url) ||
        SocialLinkRegExp.facebook.photo.test(url),
    isYoutube: (url) => SocialLinkRegExp.youtube.video.test(url) ||
        SocialLinkRegExp.youtube.short.test(url) ||
        SocialLinkRegExp.youtube.embed.test(url) ||
        SocialLinkRegExp.youtube.live.test(url) ||
        SocialLinkRegExp.youtube.shortLink.test(url) ||
        SocialLinkRegExp.youtube.videoId.test(url),
    isTracdelight: (url) => SocialLinkRegExp.tracdelight.test(url),
};
export const getSocialName = (url) => {
    if (SocialLinkValidation.isInstagram(url))
        return SocialMediaPlatforms.Instagram;
    else if (SocialLinkValidation.isTwitter(url))
        return SocialMediaPlatforms.Twitter;
    else if (SocialLinkValidation.isTiktok(url))
        return SocialMediaPlatforms.TikTok;
    else if (SocialLinkValidation.isFacebook(url))
        return SocialMediaPlatforms.Facebook;
    else if (SocialLinkValidation.isYoutube(url))
        return SocialMediaPlatforms.Youtube;
    else if (SocialLinkValidation.isTracdelight(url))
        return SocialMediaPlatforms.Tracdelight;
    return undefined;
};
export const parseInstagram = (data) => {
    const idRegex = data.match(SocialLinkRegExp.instagram.link);
    if (idRegex && idRegex[2]) {
        const postId = idRegex[2];
        const typeFromUrl = idRegex[1];
        const postType = typeFromUrl === 'tv' || typeFromUrl === 'reel' || typeFromUrl === 'p' ? typeFromUrl : 'p';
        return {
            url: `https://www.instagram.com/${postType}/${postId}/`,
            socialName: SocialMediaPlatforms.Instagram,
            postId,
            postType,
        };
    }
    const shortcodeRegex = data.match(SocialLinkRegExp.instagram.shortcode);
    if (shortcodeRegex && shortcodeRegex[1]) {
        const postType = 'p';
        const shortcode = shortcodeRegex?.[1];
        return {
            url: `https://www.instagram.com/${postType}/${shortcode}/`,
            socialName: SocialMediaPlatforms.Instagram,
            postId: shortcode,
            postType,
        };
    }
    return undefined;
};
export const parseTwitter = (data) => {
    const twitterOrXMatch = data.match(SocialLinkRegExp.twitter);
    if (!twitterOrXMatch || !twitterOrXMatch[2] || !twitterOrXMatch[3]) {
        return undefined;
    }
    const accountName = twitterOrXMatch[2];
    const postId = twitterOrXMatch[3];
    return {
        socialName: SocialMediaPlatforms.Twitter,
        accountName,
        postId,
    };
};
export const parseTiktok = (data) => {
    const urlMatch = data.match(SocialLinkRegExp.tiktok);
    if (!urlMatch || !urlMatch[0] || !urlMatch[1] || !urlMatch[2] || !urlMatch[3]) {
        return undefined;
    }
    const postUrl = urlMatch[0];
    const accountName = urlMatch[1].substring(1); // '@' entfernen
    const embedType = urlMatch[2];
    const postId = urlMatch[3];
    return {
        socialName: SocialMediaPlatforms.TikTok,
        postUrl,
        postId,
        accountName,
        embedType,
    };
};
export const parseFacebook = (data) => {
    const socialName = SocialMediaPlatforms.Facebook;
    const facebookUrlMatch = data.match(SocialLinkRegExp.facebook.postVideo);
    if (facebookUrlMatch && facebookUrlMatch[0] && facebookUrlMatch[1]) {
        const postUrl = facebookUrlMatch[0];
        const embedType = facebookUrlMatch[1] === 'posts' ? 'posts' : 'videos';
        return {
            socialName,
            postUrl,
            embedType,
        };
    }
    const facebookUrlReelMatch = data.match(SocialLinkRegExp.facebook.reel);
    if (facebookUrlReelMatch && facebookUrlReelMatch[0]) {
        const postUrl = facebookUrlReelMatch[0];
        const embedType = 'reel';
        return {
            socialName,
            postUrl,
            embedType,
        };
    }
    const facebookUrlPhotoMatch = data.match(SocialLinkRegExp.facebook.photo);
    if (facebookUrlPhotoMatch && facebookUrlPhotoMatch[0]) {
        const postUrl = facebookUrlPhotoMatch[0];
        const embedType = 'posts';
        return {
            socialName,
            postUrl,
            embedType,
        };
    }
    const facebookPostMatch = data.match(SocialLinkRegExp.facebook.embedPost);
    if (facebookPostMatch && facebookPostMatch[1]) {
        const postUrl = decodeURIComponent(facebookPostMatch[1]);
        const embedType = 'posts';
        return {
            socialName,
            postUrl,
            embedType,
        };
    }
    const facebookVideoMatch = data.match(SocialLinkRegExp.facebook.embedVideo);
    if (facebookVideoMatch && facebookVideoMatch[1]) {
        const postUrl = decodeURIComponent(facebookVideoMatch[1]);
        const embedType = 'videos';
        return {
            socialName,
            postUrl,
            embedType,
        };
    }
    const facebookEmbedPhotoOrShortMatch = data.match(SocialLinkRegExp.facebook.embedPhoto) || data.match(SocialLinkRegExp.facebook.short);
    if (facebookEmbedPhotoOrShortMatch && facebookEmbedPhotoOrShortMatch[0]) {
        const postUrl = decodeURIComponent(facebookEmbedPhotoOrShortMatch[0]);
        const embedType = 'posts';
        return {
            socialName,
            postUrl,
            embedType,
        };
    }
    return undefined;
};
export const parseYoutube = (data) => {
    const youtubeVideoMatch = data.match(SocialLinkRegExp.youtube.video);
    if (youtubeVideoMatch && youtubeVideoMatch[1]) {
        const postId = youtubeVideoMatch[1];
        const postUrl = `https://www.youtube.com/watch?v=${postId}`;
        const embedType = 'video';
        return {
            url: postUrl,
            socialName: SocialMediaPlatforms.Youtube,
            postUrl,
            postId,
            embedType,
        };
    }
    const youtubeEmbedMatch = data.match(SocialLinkRegExp.youtube.embed);
    if (youtubeEmbedMatch && youtubeEmbedMatch[1]) {
        const postId = youtubeEmbedMatch[1];
        const postUrl = `https://www.youtube.com/watch?v=${postId}`;
        const embedType = 'video';
        return {
            url: postUrl,
            socialName: SocialMediaPlatforms.Youtube,
            postUrl,
            postId,
            embedType,
        };
    }
    const youtubeShortsMatch = data.match(SocialLinkRegExp.youtube.short);
    if (youtubeShortsMatch && youtubeShortsMatch[1]) {
        const postId = youtubeShortsMatch[1];
        const postUrl = `https://www.youtube.com/shorts/${postId}`;
        const embedType = 'short';
        return {
            url: postUrl,
            socialName: SocialMediaPlatforms.Youtube,
            postUrl,
            postId,
            embedType,
        };
    }
    const youtubeShortLinkMatch = data.match(SocialLinkRegExp.youtube.shortLink);
    if (youtubeShortLinkMatch && youtubeShortLinkMatch[1]) {
        const postId = youtubeShortLinkMatch[1];
        const postUrl = `https://youtu.be/${postId}`;
        const embedType = 'video';
        return {
            url: postUrl,
            socialName: SocialMediaPlatforms.Youtube,
            postUrl,
            postId,
            embedType,
        };
    }
    const youtubeLiveMatch = data.match(SocialLinkRegExp.youtube.live);
    if (youtubeLiveMatch && youtubeLiveMatch[1]) {
        const postId = youtubeLiveMatch[1];
        const postUrl = `https://www.youtube.com/live/${postId}`;
        const embedType = 'video';
        return {
            url: postUrl,
            socialName: SocialMediaPlatforms.Youtube,
            postUrl,
            postId,
            embedType,
        };
    }
    const youtubeVideoId = data.match(SocialLinkRegExp.youtube.videoId);
    if (youtubeVideoId && youtubeVideoId[1]) {
        const postId = youtubeVideoId?.[1];
        const postUrl = `https://youtu.be/${postId}`;
        const embedType = 'video';
        return {
            url: postUrl,
            socialName: SocialMediaPlatforms.Youtube,
            postUrl,
            postId,
            embedType,
        };
    }
    return undefined;
};
export const parseTracdelight = (data) => {
    const tracdelightMatch = data.match(SocialLinkRegExp.tracdelight);
    if (!tracdelightMatch) {
        return undefined;
    }
    const accessKeyMatch = data.match(/accesskey=([a-zA-Z0-9]{32})/);
    const widgetIdMatch = data.match(/'widget':'([a-zA-Z0-9]{16})/);
    const accessKey = accessKeyMatch?.[1] ?? '';
    const widgetId = widgetIdMatch?.[1] ?? '';
    if (!accessKey && !widgetId) {
        return undefined;
    }
    return {
        socialName: SocialMediaPlatforms.Tracdelight,
        accessKey,
        widgetId,
    };
};
// eslint-disable-next-line @rushstack/typedef-var -- disable scoped to legacy integration boundary in this file
export const SocialLinkUtils = {
    SocialLinkRegExp,
    SocialLinkValidation,
    getSocialName,
    SocialMediaPlatforms,
    parseInstagram,
    parseTwitter,
    parseTiktok,
    parseFacebook,
    parseYoutube,
    parseTracdelight,
};
//# sourceMappingURL=socials.js.map